module.exports = __webpack_public_path__ + "static/media/路径规划.7e707b54.jpg";